import { render, staticRenderFns } from "./Pelamar.vue?vue&type=template&id=57864c0e"
import script from "./Pelamar.vue?vue&type=script&lang=js"
export * from "./Pelamar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports